var parseJwt = function (token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(atob(base64)
        .split("")
        .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    })
        .join(""));
    return JSON.parse(jsonPayload);
};
var getJWTPublicClaim = function () {
    var data = localStorage.getItem("tokens");
    if (!data) {
        return {};
    }
    var token = JSON.parse(data);
    return parseJwt(token.accessToken);
};
var getRoles = function () {
    return getJWTPublicClaim().roles || ["USER"];
};
var getBusinessUnit = function () {
    return getJWTPublicClaim().business_unit_id || "";
};

export { getBusinessUnit, getJWTPublicClaim, getRoles };
